import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import adminsRu from './ru/admins.json';
import agreementsRu from './ru/agreements.json';
import authRu from './ru/auth.json';
import commonRu from './ru/common.json';
import dashboardRu from './ru/dashboard.json';
import documentsRu from './ru/documents.json';
import errorsRu from './ru/errors.json';
import feeTariffsRu from './ru/feeTariffs.json';
import rbacRu from './ru/rbac.json';
import settingsRu from './ru/settings.json';
import usersRu from './ru/users.json';

/**
 * Инициализирует i18next с русским языком по умолчанию.
 *
 * Бандлы разделены по неймспейсам: `common`, `errors`, `auth`, `dashboard`,
 * `settings`, `users`, `admins`, `rbac`, `documents`. Ключи в `errors` совпадают с `code` из ApiError бэкенда.
 */
export const i18n_ = i18n;

void i18n.use(initReactI18next).init({
  resources: {
    ru: {
      common: commonRu,
      errors: errorsRu,
      auth: authRu,
      dashboard: dashboardRu,
      documents: documentsRu,
      settings: settingsRu,
      users: usersRu,
      rbac: rbacRu,
      feeTariffs: feeTariffsRu,
      agreements: agreementsRu,
      admins: adminsRu,
    },
  },
  lng: 'ru',
  fallbackLng: 'ru',
  defaultNS: 'common',
  ns: [
    'common',
    'errors',
    'auth',
    'dashboard',
    'documents',
    'settings',
    'users',
    'rbac',
    'feeTariffs',
    'agreements',
    'admins',
  ],
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
});

export default i18n;
